<div id="preloader" *ngIf="isLoading">
    <div class="loader-cubes">
        <div class="loader-cube1 loader-cube"></div>
        <div class="loader-cube2 loader-cube"></div>
        <div class="loader-cube4 loader-cube"></div>
        <div class="loader-cube3 loader-cube"></div>
    </div>
</div>